import React, { useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

export default function MobileTest(props) {
  const [data, setData] = useState(null);

  return (
    <>
        <BarcodeScannerComponent
          width={500}
          height={500}
          onUpdate={(err, result) => {
            let text = null;
            if (result) {
             text = parseInt(result.text, 10);
            }
            if (text > 0) {
              setData(text)
            }
          }}
          // onError={(err) => console.error("error", err)}
          facingMode={"environment"}
        />
      <p>The barcode scan reads as:</p>
      <h2 className="text-primary">{data}</h2>
    </>
  );
}
